import request from '../../config/axiosConfig';
import { CREATE_TAG_VIDEO, DELETE_TAG_VIDEO, GET_LIST_TAGS_VIDEO, GET_TAG_VIDEO_INFO, UPDATE_TAG_POSITION, UPDATE_TAG_VIDEO } from '../../constants/apiEndPoint';

export const getListTagVideosRequest = async (data) => {
  const result = await request({
    url: GET_LIST_TAGS_VIDEO,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const getTagVideoInfoRequest = async (data) => {
    const result = await request({
      url: GET_TAG_VIDEO_INFO,
      method: 'POST',
      data,
    });
    return result?.data.data;
  };
  
  export const createTagVideoRequest = async (data) => {
    const result = await request({
      url: CREATE_TAG_VIDEO,
      method: 'POST',
      data,
    });
    return result?.data;
  };
  
  export const updateTagVideoRequest = async (data) => {
    const result = await request({
      url: UPDATE_TAG_VIDEO,
      method: 'POST',
      data,
    });
    return result?.data;
  };
  
  export const deleteTagVideoRequest = async (data) => {
    const result = await request({
      url: DELETE_TAG_VIDEO,
      method: 'POST',
      data,
    });
    return result?.data;
  };

  
  export const updateTagPositionRequest = async (data) => {
    const result = await request({
      url: UPDATE_TAG_POSITION,
      method: 'POST',
      data,
    });
    return result?.data;
  };
